import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth.js';
import { ApiError } from '../api.js';

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const rememberedEmail = localStorage.getItem('csoki_last_email') ?? '';
  const [email, setEmail] = useState(rememberedEmail);
  const [pin, setPin] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email, pin);
      nav('/seller/upload', { replace: true });
    } catch (e) {
      if (e instanceof ApiError && e.code === 'too_many_attempts') {
        setErr('Too many tries. Wait an hour and try again.');
      } else if (e instanceof ApiError && e.code === 'bad_credentials') {
        setErr('Wrong email or PIN.');
      } else {
        setErr('Something went wrong.');
      }
      setBusy(false);
    }
  }

  function useDifferent() {
    localStorage.removeItem('csoki_last_email');
    setEmail('');
  }

  return (
    <div className="auth-page">
      <h1>Sign in</h1>
      <p className="auth-sub">Welcome back to the shop.</p>
      <form onSubmit={onSubmit} className="form">
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
            disabled={!!rememberedEmail && email === rememberedEmail}
          />
        </label>
        {rememberedEmail && email === rememberedEmail && (
          <button type="button" className="link" onClick={useDifferent}>
            Use a different account
          </button>
        )}
        <label>
          PIN (4 digits)
          <input
            type="password"
            inputMode="numeric"
            pattern="\d{4}"
            maxLength={4}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
            autoFocus={!!rememberedEmail}
            required
          />
        </label>
        {err && <div className="err">{err}</div>}
        <button type="submit" disabled={busy}>
          {busy ? '…' : 'Sign in'}
        </button>
      </form>
      <p>
        No account? <Link to="/seller/register">Register</Link>
      </p>
      <p>
        <Link to="/">Back to catalog</Link>
      </p>
    </div>
  );
}
